import { ChartDimensions } from '@ardoq/graph';
import {
  LabelColumnBackground,
  TickLabelRowContainer,
  XAxisLine,
  XAxisText,
  XAxisTickmark,
} from './styles';

type DomainRangeLabelRowArgs = {
  visibleDomainRowLabel: string | null;
  dimensions: ChartDimensions;
};
const DomainRangeLabelRow = ({
  visibleDomainRowLabel,
  dimensions,
}: DomainRangeLabelRowArgs) => {
  const {
    margin,
    chart: { width },
  } = dimensions;
  return (
    <TickLabelRowContainer>
      <LabelColumnBackground
        style={{
          width: margin.left,
        }}
      />
      <XAxisText
        style={{
          left: margin.left + width * 0.5,
        }}
      >
        {visibleDomainRowLabel}
      </XAxisText>
      <XAxisTickmark />
      <XAxisLine
        style={{
          left: margin.left,
          width: width,
        }}
      />
    </TickLabelRowContainer>
  );
};

export { DomainRangeLabelRow };
